<!--
  @Author 22030124/xieyq
  @Date 2024-03-27 15:30:50
  @Description 模块组件
-->
<template>
  <div :class="scope.clsPrefix">
    <!-- 头部 -->
    <header :class="`${scope.clsPrefix}_head`">
      <!-- 标题 -->
      <div :class="`${scope.clsPrefix}_tit`" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <h5 v-else :class="`${scope.clsPrefix}_tit`">{{ title }}</h5>
      <!-- 头部右侧区域 -->
      <!-- 右侧区域 -->
      <div :class="`${scope.clsPrefix}_extra`" v-if="$slots.extra">
        <slot name="extra"></slot>
      </div>
    </header>
    <!-- 中心内容 -->
    <div :class="`${scope.clsPrefix}_body`">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'HelModule',
  // 参数
  props: {
    // 标题
    title: String
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'hel-module'
      }
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {}
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'hel-module';
.#{$class-prefix} {
  position: relative;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  // 头部
  &_head {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    height: 20px;
  }
  // &_extra {
  //   flex: 1;
  //   display: flex;
  //   flex-direction: row;
  //   align-items: center;
  //   justify-content: flex-end;
  // }
  // 标题
  &_tit {
    margin: 0;
    color: rgb(30, 34, 38);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    flex: 1;
  }
  // 主体内容
  &_body {
    position: relative;
    flex: 1;
  }
}
</style>
